import * as React from "react";
import styles from "./reset_all_button.module.sass";

type ResetAllButtonProps = {
  onReset: () => void;
  isFilterAdjusted: boolean;
};

export const ResetAllButton = ({
  isFilterAdjusted,
  onReset,
}: ResetAllButtonProps): JSX.Element => (
  <button
    type="button"
    className={styles.resetAllButton}
    disabled={!isFilterAdjusted}
    onClick={() => {
      onReset();
    }}
  >
    Zrušit vybrané parametry
  </button>
);
